<template>
  <div>
    <i ref="btn"></i>
  </div>
</template>

<script>
import {initValidation, verifyValidation, verifyValidationV2} from "@/api/user";
import {Toast} from "vant";
import {mapGetters} from 'vuex'

export default {
  name: "Geet",
  data() {
    return {
      captchaObjData: {},
      captchaObj: {},
      requestLocked: false, //防重复提交
    }
  },
  // 接受父组件传递的值，用来控制图形验证的加载
  // appendBox绑定在哪个盒子上（product="popup" 可用） product="bind" 点击即可弹出
  props: ["isGeet", 'product', 'appendBox', 'userName'],
  computed: {
    ...mapGetters(['language'])
  },
  watch: {
    // 监听参数的变化，调用极验
    isGeet() {
      this.GtCaptcha();
    }
  },
  methods: {
    GtCaptcha() {
      if (this.requestLocked) return false
      var _this = this
      var map = {
        'zh-CN': 'zho',
        'zh-HK': 'zho-hk',
        'zh-TW': 'zho-tw',
        'zh-TC': 'zho-hk',
        'en': 'eng',
        'ko': 'kor',
        'ja': 'jpn',
        'ru': 'rus',
        'fa': 'fas',
        'uk': 'ukr',
        'es': 'spa',
        'vi': 'vie',
      }
      console.log(map[_this.language], 'map[_this.language]')
      _this.$initGeet({
        captchaId: 'ee5156af6d3d77cec9ec422ab7409ac8',
        product: _this.product,
        language: map[_this.language],
        nativeButton: {
          height: '100%',
          width: '100%'
        },
        rem: 0.85,
        nextWidth: '100%',
        timeout: 50000
      }, function (captchaObj) {
        captchaObj.appendTo('#captchaBox');
        _this.$refs.btn.addEventListener("click", function demo() {
          // 极验图片触发之后，修改控制变量额布尔值，实现再次触发
          _this.$emit("clickChange", false);
          if (_this.isGeet) {
            captchaObj.showCaptcha();
          }
        });
        // 为此页面的虚拟按钮添加点击事件
        captchaObj.onReady(function () {
          captchaObj.showCaptcha();
          _this.$nextTick(() => {
            _this.requestLocked = false
          })
        }).onSuccess(function () {
          var result = captchaObj.getValidate();
          console.log(result, 'result')
          let param = {
            lotNumber: result.lot_number,
            captchaOutput: result.captcha_output,
            passToken: result.pass_token,
            genTime: result.gen_time,
          };
          // 拿到参数后极验第二步验证
          verifyValidationV2(param).then(res => {
            console.log(res, 22222)
            if (res.code == 200) {
              _this.$emit("geetPath", res.data);
            } else {
              Toast(res.msg)
              captchaObj.showCaptcha();
            }
          })

        }).onError(function () {
          console.log('图形验证失败')
        });
      })
    }
    /*GtCaptcha() {
      if (this.requestLocked) return false
      let _this = this;
      // 此url是极验官网的测试请求地址，加随机数防止缓存
      var datas = {
        userName: this.userName,
        client: 'web',
      }
      this.requestLocked = true
      initValidation(datas).then(res => {
        console.log("1,页面初始化，调用极验接口1，进行图形验证码的加载");
        // 极验第一次，请求回来的参数
        console.log(res);
        let data = this.captchaObjData = res.data
        console.log(data)
        var handlerEmbed = function (captchaObj) {
          _this.captchaObj = captchaObj
          if (_this.appendBox) {
            captchaObj.appendTo("#captchaBox")
          }
          //   图形验证成功
          captchaObj.onReady(function () {
            captchaObj.verify();
            _this.$nextTick(() => {
              _this.requestLocked = false
            })
          })
            .onSuccess(function () {
              var result = captchaObj.getValidate();
              let param = {
                challenge: result.geetest_challenge,
                client: 'web',
                seccode: result.geetest_seccode,
                session: _this.captchaObjData.session,
                validate: result.geetest_validate,
              };
              // 极验校验的参数，将其传给服务端，进行校验。
              console.log(
                "3，图形验证通过，将数据传递给父组件，进行服务端验证"
              );
              // 拿到参数后极验第二步验证
              verifyValidation(param).then(res => {
                console.log(res, 22222)
                if (res.code == 200) {
                  _this.$emit("geetPath", res.data);
                } else {
                  _this.$notify({
                    message: res.msg,
                    iconClass: 'iconfont icon-cuowu1',
                    customClass: 'errorIcon flex-center',
                    showClose: false
                  })
                  captchaObj.verify();
                }
              })

            })
            .onError(function () {
              //   图形验证失败
            });
          //   为此页面的虚拟按钮添加点击事件
          // _this.$refs.btn.addEventListener("click", function demo() {
          //   // 极验图片触发之后，修改控制变量额布尔值，实现再次触发
          //   _this.$emit("clickChange", false);
          //   if (_this.isGeet) {
          //     captchaObj.verify();
          //   }
          // });
        };
        console.log([_this.language])
        var map = {
          'zh-CN': 'zh-cn',
          'zh-HK': 'zh-hk',
          'zh-TW': 'zh-tw',
          'zh-TC': 'zh-hk',
          'en': 'en',
          'ko': 'ko',
          'ja': 'ja',
          'ru': 'ru',
          'fa': 'en',
          'uk': 'en',
          'es': 'es',
          'vi': 'vi',
        }
        //   初始化极验
        _this.$initGeet(
          {
            gt: data.gt,
            challenge: data.challenge,
            product: _this.product,
            offline: !data.success,
            https: true,
            new_captcha: data.new_captcha,
            width: '100%',
            lang: map[_this.language]
          },
          handlerEmbed
        );
      }).catch(() => {
        _this.$nextTick(() => {
          _this.requestLocked = false
        })
      });
    }*/
  },

}
</script>

<style>
.geetest_box {
  direction: ltr;
}
</style>



// WEBPACK FOOTER //
// src/compontents/Geet.vue